import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Shield, Globe, Zap, Users, Search, Award } from 'lucide-react';

export default function FeaturesSection() {
  const features = [
    {
      icon: Shield,
      title: 'Verified Vendors',
      description: 'All vendors undergo rigorous verification to ensure quality and reliability for your operations.',
    },
    {
      icon: Globe,
      title: 'Global Marketplace',
      description: 'Access industrial drones from verified vendors in over 100 countries worldwide.',
    },
    {
      icon: Zap,
      title: 'Instant Matching',
      description: 'Advanced algorithms connect you with the perfect UAV for your specific industry needs.',
    },
    {
      icon: Users,
      title: 'Expert Support',
      description: 'Dedicated support team with aerospace and industrial expertise available 24/7.',
    },
    {
      icon: Search,
      title: 'Advanced Filters',
      description: 'Filter by payload capacity, flight time, range, and specialized equipment requirements.',
    },
    {
      icon: Award,
      title: 'Quality Assured',
      description: 'Every listing meets strict quality standards with detailed specifications and certifications.',
    },
  ];

  return (
    <section className="py-20 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
              Why Choose UAVsForSale?
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              The most comprehensive and trusted platform for industrial drone procurement
            </p>
          </div>

          {/* Features grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <Card 
                  key={feature.title}
                  className={`group hover:shadow-xl transition-all duration-300 border-border hover:border-primary/50 animate-slide-up stagger-${(index % 6) + 1}`}
                >
                  <CardHeader className="space-y-4">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <CardTitle className="text-xl">{feature.title}</CardTitle>
                    <CardDescription className="text-base leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardHeader>
                </Card>
              );
            })}
          </div>

          {/* Categories preview */}
          <div className="mt-20">
            <h3 className="text-2xl sm:text-3xl font-bold text-center mb-12">
              Browse by Category
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {[
                'Heavy-Lift',
                'Thermal Inspection',
                'Photogrammetry',
                'Agricultural',
                'Surveillance',
                'Delivery',
                'Racing',
                'Cinematography',
                'Search & Rescue',
                'Mapping',
              ].map((category, index) => (
                <div
                  key={category}
                  className={`p-4 rounded-lg bg-muted hover:bg-primary/10 border border-border hover:border-primary/50 text-center cursor-pointer transition-all duration-300 animate-fade-in stagger-${(index % 6) + 1}`}
                >
                  <span className="text-sm font-medium">{category}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}